<template lang="pug">
  div.hidden-frame
    iframe#hidden-frame(ref="frame")
</template>

<script>
import AppState from '@/plugins/appstate'

export default {
  name: 'hidden-dialog',
  created () {
    AppState.$on('show-hidden-dialog', (data, cb) => {
      const doc = this.$refs.frame.contentWindow.document
      doc.open()
      doc.write(data.body)
      doc.close()
    })
  }
}
</script>

<style lang="scss" scoped>
.hidden-frame {
  position: absolute;
  top: -2000px; left: -2000px;
  width: 10px; height: 10px;
}
</style>
